module.exports = __webpack_public_path__ + "img/Khatete-Nathan.36010369.jpg";